import defaultTheme from './default';
import type { ICartTheme } from './types/ICart';

export const CartTheme: ICartTheme = {
  ...defaultTheme,

  defaultDarkColor: 'var(--dark, #000000 )',
  warmGrey: '#efefef',
};
